<template>
    <div class="product-component" @click="go">
      <img class="product-component-img" mode="aspectFill" :src="backImg" />
      <div class="product-component-button">
        <p class="product-component-button-text">即刻拥有</p>
      </div>
    </div>
  </template>
   
  <script>
  import { jump } from '@/util';
  export default {
    name: "Product-Component",
    props: {
      backImg: {
        type: String,
        default: ''
      },
      path: {
        type: String,
        default: ''
      },
      param: {
        type: String,
        default: ''
      },
    },
    methods: {
      go() {
        let url = this.path
        if (this.param && this.param.length > 0) {
          url += `&query=${encodeURI(this.param)}`
        }
        jump('wx7067da25149f33f7', url)
      }
    },
  };
  </script>
   
  <style lang="scss" scoped>
    .product-component {
      width: 100%;
      aspect-ratio: 1920/796;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: flex-end;
      padding-right: 1.67rem;
      padding-bottom: 0.97rem;
      box-sizing: border-box;
      &-img {
        position: absolute;
        left: 0;
        width: 100%;
        top: 0;
        height: 100%;
      }
      &-button {
        z-index: 2;
        width: 1.557rem;
        height: 0.4rem;
        background-color: #222222;
        border-radius: 0.025rem;
        display: flex;
        align-items: center;
        justify-content: center;
        &-text {
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 400;
          font-size: 0.234rem;
          color: #FFFFFF;
          line-height: 0.156rem;
        }
      }
    }
  </style>